import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "./common/AuthApp";
import { sendOtp } from "../../service/auth";
import "../../Home.css";
import { toast } from "react-toastify";

const EmployerLogin = () => {
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();
  const [btnloading, setBtnLoading] = useState(false);

//   toast.configure();

  const handleSendOtp = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const phone = formData.get("phone");
    const role = formData.get("role");

    try {
      setBtnLoading(true);
      const result = await sendOtp(phone, role);
      if (result.status) {
        // toast.success("OTP sent successfully!");
        navigate("/employer/verify-otp", { state: { phone, role, toastMessage: "OTP sent successfully!" } });
      } else {
        toast.error(result.message || "Failed to send OTP");
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <PageLayout>
      <section className="innerBnrNav">
        <div className="bnrNav">
          <div className="site-width">
            <div className="bnrNavWrap">
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="javascript:void(0)">Employer Login</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="loginFormSection pt-50 pb-50 bg1">
        <div className="site-width">
          <div className="row align-item-center justify-content-center">
            <div className="col-md-6">
              <div className="loginSection">
                <div className="loginForm">
                  <div className="right-sidebar-box">
                    <div className="">
                      <div
                        className="titleSection text-center"
                        style={{ marginRight: "20px" }}
                      >
                        <h2>Employer Login</h2>
                      </div>
                      <form onSubmit={handleSendOtp}>
                        <div className="row justify-content-center">
                          <div className="col-md-4">
                            <div className="loginImgSec">
                              <img
                                src={`${process.env.PUBLIC_URL}/assets/img/icons/login-img.svg`}
                                alt="img"
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group hj-form">
                              {/* <label for="mobile">Phone Number</label> */}
                              <input
                                type="text"
                                className="form-control"
                                name="phone"
                                placeholder="Enter Mobile Number"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                required
                                maxLength={10}
                                minLength={10}
                                pattern="\d{10}"
                              />
                              <input
                                type="hidden"
                                name="role"
                                value="employer"
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <button
                              type="submit"
                              className="mt-4 w-100 normalbtn"
                              disabled={btnloading}
                            >
                              {btnloading ? (
                                <span>
                                  <i
                                    className="fa fa-spinner fa-spin"
                                    style={{ marginRight: "8px" }}
                                  ></i>
                                  Sending...
                                </span>
                              ) : (
                                "Send OTP"
                              )}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default EmployerLogin;
